import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Button, Box, Checkbox, TableSortLabel, TableFooter } from "@mui/material";
import { Container } from "@mui/system";
import axios, { AxiosResponse } from "axios";
import React, { FormEvent, useEffect, useRef, useState } from "react";
import { baseAPIUrl } from "../../../Utils/BaseAPI";
// import './Linea.css'
import DriverType from "./Interfaces/DriverInterface";
import grid from "./grid";
import FilterColumnsType from '../../../Interfaces/FilterColumnsInterface';
import GridInterface from "../../../Interfaces/GridInterface";
import { BaseGrid } from "../../../Utils/BaseGrid";
import PaginationType from "../../../Interfaces/PaginationInterface";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FieldExtractor } from "../../../Utils/field-extractor";

const Linea = () => {
  const [dataArr, updateArr] = useState<DriverType[]>([]);
  const [selectedIds, updateSelectedIds] = useState<number[]>([]);
  const [parentViewModel, updateParentViewModel] = useState<any>();
  const [filterColumns, updateFilterColumns] = useState<FilterColumnsType[]>([]);

  type Order = 'asc' | 'desc';

  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<keyof GridInterface>('name');
  const [filter, setFilter] = useState<string>();
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);


  // const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<PaginationType>();
  const [columns, setColumns] = useState([]);
  const [selected, setSelected] = useState([]);
  const [rows, setRows] = useState<object[]>([]);
  const [onRequest, setOnRequest] = useState<Function>();
  // const [filterColumns, setFilterColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState<string[]>([]);
  const [uomList, setUomList] = useState([]);

  const navigate = useNavigate();

  // let {
  //   filter,
  //   loading,
  //   pagination,
  //   columns,
  //   selected,
  //   rows,
  //   onRequest,
  //   filterColumns,
  //   visibleColumns,
  //   getSelectedString,
  //   uomList,
  // } = BaseGrid(grid, baseAPIUrl + 'GetLineGrid');

  useEffect(() => {
    setFilter(filter);
    setLoading(loading);
    setPagination(pagination);
    setSelected(selected);
    setRows(rows);
    setOnRequest(onRequest);
    updateFilterColumns(filterColumns);
    setVisibleColumns(visibleColumns);
    setUomList(uomList);

    window.removeEventListener('message', messageCallBack);
    window.addEventListener("message", messageCallBack, false);
    // updateGrid();
    grid.forEach((el: GridInterface) => {
      filterColumns.push({
        columnName: el.name,
        columnSearchValue: null,
        columnVisible: el.visible,
        columnSearchable: el.searchable
      })
    });
  }, []);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const messageCallBack = (e: any) => {
    const urls = process.env.REACT_APP_ALLOWED_URLS?.split(',');
    if (urls?.includes(e.origin)) {
      if (e?.data && e?.data?.type == 'updateViewModel') {
        updateParentViewModel(e.data.viewModel);
      }
    }
  }

  const createDriver = () => {
    navigate('create');
  }

  const editDriver = () => {
    let idToEdit: number = selectedIds[0];
    navigate(`edit/${idToEdit}`);
  }

  const deleteDriver = () => {
    let idToDelete: number = selectedIds[0];
    Swal.fire({
      title: 'Vuoi eliminare i driver selezionati?',
      showCancelButton: true,
      confirmButtonText: 'Cancella',
      denyButtonText: `Annulla`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios.post(`${baseAPIUrl}DeleteDriver`, {
          Id: idToDelete
        })
          .then((result: AxiosResponse) => {
            if (result && result.data.Success) {
              setTimeout(() => {
                updateGrid();
                updateSelectedIds([]);
              }, 500);
            }
          })
      } else if (result.isDenied) {
        Swal.close();
      }
    })
  }

  const updateSelectedIdsFun = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    let updatedIds = [...selectedIds];
    if (e.target.checked) {
      updatedIds.push(id);
    } else {
      updatedIds = updatedIds.filter((selectedId) => selectedId !== id);
    }
    updateSelectedIds(updatedIds);
  };

  const handleInputEvent = (e: FormEvent<HTMLInputElement>, index: number) => {
    const newFilterColumns = [...filterColumns];
    var element = e.target as HTMLInputElement;
    newFilterColumns[index].columnSearchValue = element.value;
    // filterColumns = newFilterColumns;
    updateFilterColumns(newFilterColumns);
    updateGrid();
  };

  const selectAllClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    let bool = e.target.checked;
    if (bool) {
      let allIds = dataArr?.map((el) => {
        return el.id;
      })
      if (allIds && allIds.length > 0) {
        updateSelectedIds(allIds);
      }
    } else {
      updateSelectedIds([]);
    }
  };

  const updateGrid = () => {
    let checkFilter = (el: FilterColumnsType) => el.columnSearchValue != null;
    if (filterColumns.some(checkFilter) && page > 1) {
      setPage(1);
    }
    
    // onRequest({
    //   pagination: pagination,
    //   filter: filter
    // });
    axios.get(baseAPIUrl + 'GetDriverGrid')
      .then((result: AxiosResponse) => {
        if (result && result.data) {
          let resultForMapping = FieldExtractor.extractArrayObjectField(result.data.Data, '', null, true) as DriverType[];
          updateArr(resultForMapping);
        }
      })
  };

  useEffect(() => {
    updateGrid();
  }, [filter])

  const updateViewModel = () => {
    let viewModelObj = {};
    if (selectedIds.length == 1) {
      viewModelObj = {
        CanEdit: true,
        CanNew: false,
        CanDelete: true
      }
    } else if (selectedIds.length > 1) {
      viewModelObj = {
        CanEdit: false,
        CanNew: false,
        CanDelete: false
      }
    } else {
      viewModelObj = {
        CanEdit: false,
        CanNew: true,
        CanDelete: false
      }
    }
    return viewModelObj;
  };

  useEffect(() => {
    let viewModelObj = updateViewModel();
    let datatablesEventsSupportViewModelObj = {
      CheckIds: selectedIds,
      ClickId: null,
      FilterCounter: 0,
      FilterDate: "1/1/2022 - 31/12/2023",
      Generic: null,
      HasFilter: false,
      OptionalId: null,
      QueryUrlId: null,
      Row: null
    };
    window.parent.postMessage({
      DatatablesEventsSupportViewModel: datatablesEventsSupportViewModelObj,
      type: 'updateViewModel',
      viewModel: viewModelObj 
    }, '*');
  }, [selectedIds]);

  const createSortHandler = (property: keyof GridInterface) => (event: React.MouseEvent<unknown>) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    console.log('ciao');
    // const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof GridInterface) => {

    // };
  };

  return (
    <React.Fragment>
      <div className="mt-10 mb-10 inline-flex items-center justify-center gap-10">
        <Button variant="contained" onClick={createDriver} color="success" disabled={!parentViewModel?.CanNew}>Nuovo</Button>
        <Button variant="contained" onClick={editDriver} disabled={!parentViewModel?.CanEdit}>Modifica</Button>
        <Button variant="contained" onClick={deleteDriver} color="error" disabled={!parentViewModel?.CanDelete}>Elimina</Button>
        <Button variant="contained" onClick={updateGrid} color="info">Aggiorna</Button>
      </div>
      <div className="global-filter">
        <input type="text" value={filter} placeholder="Cerca..."></input>
      </div>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table" className="table-center">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    onChange={selectAllClick}
                    indeterminate={selectedIds.length > 0 && selectedIds.length < dataArr.length}
                    checked={dataArr!.length > 0 && selectedIds.length === dataArr.length}
                    inputProps={{
                      'aria-label': 'select all',
                    }}
                  />
                </TableCell>
                {grid.map((el, index) => {
                  // return <TableCell key={index}>{el.label}</TableCell>
                  return (
                    <TableCell
                      key={el.name}
                      sortDirection={orderBy === el.name ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === el.name}
                        direction={orderBy === el.name ? order : 'asc'}
                        onClick={createSortHandler(el.name as keyof GridInterface)}
                      >
                        {el.label}
                      </TableSortLabel>
                    </TableCell>)
                })}
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                {grid.map((el, index) => {
                  return <TableCell key={index}><input type="text" onChange={(e) => { handleInputEvent(e, index) }}></input></TableCell>
                })}
              </TableRow>
            </TableHead>
            <TableBody id="lines-table">
              {dataArr?.map((item) => {
                const isItemSelected = selectedIds.includes(item.id);
                return (
                  <TableRow
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={isItemSelected}
                    key={item?.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell><input type="checkbox" checked={isItemSelected} onChange={(e) => { updateSelectedIdsFun(e, item?.id) }}></input></TableCell>
                    <TableCell>{item?.id}</TableCell>
                    <TableCell>{item?.boxId}</TableCell>
                    <TableCell>{item?.name}</TableCell>
                    <TableCell>{item?.implementation}</TableCell>
                    <TableCell>{item?.category}</TableCell>
                    <TableCell>{item?.configurationDriver}</TableCell>
                    <TableCell>{item?.diverterNumber}</TableCell>
                    <TableCell>{item?.hasDiverterNumber}</TableCell>
                  </TableRow>);
              })}
            </TableBody>
          </Table>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { label: 'Tutti', value: -1 }]}
            component="div"
            count={dataArr?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

        </TableContainer>

      </Paper>
    </React.Fragment>
  );
};

export default Linea;